// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';

import makeHistoryItemBetslipHeaderPropsSelector from './HistoryItemBetslipHeader.selector';

import HistoryItemBetslipHeader from '.';

type HistoryItemBetslipHeaderContainerProps = {
  className?: string;
  betslipStatus: string;
  betslipType: string;
  winnings?: number;
  outcomes: Array<unknown>;
};

const HistoryItemBetslipHeaderContainer = ({ outcomes, ...ownProps }: HistoryItemBetslipHeaderContainerProps) => {
  const firstOutcomeBetId = outcomes?.[0]?.betId;

  const selectorProps = useMemo(() => ({ outcomes, betId: firstOutcomeBetId }), [outcomes, firstOutcomeBetId]);

  const selector = makeHistoryItemBetslipHeaderPropsSelector();
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <HistoryItemBetslipHeader {...enhancedProps} />;
};

export default HistoryItemBetslipHeaderContainer;
